import { SVGProps } from './SVGProps';

const XClose = ({ fill = 'white', width = '24', height = '24', stroke, ...rest }: SVGProps) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g clipPath="url(#clip0_1986_2231)">
        <mask
          id="mask0_1986_2231"
          // style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="24"
          height="24"
        >
          <path d="M24 0H0V24H24V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_1986_2231)">
          <mask
            id="mask1_1986_2231"
            // style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="24"
            height="24"
          >
            <path d="M24 0H0V24H24V0Z" fill="white" />
          </mask>
          <g mask="url(#mask1_1986_2231)">
            <g opacity="0.1">
              <mask
                id="mask2_1986_2231"
                // style="mask-type:luminance"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <path d="M24 0H0V24H24V0Z" fill="white" />
              </mask>
              <g mask="url(#mask2_1986_2231)">
                <path
                  d="M24 12C24 9.62663 23.2962 7.30655 21.9776 5.33316C20.6591 3.35977 18.7849 1.8217 16.5922 0.913451C14.3995 0.00519943 11.9867 -0.232441 9.65892 0.230582C7.33115 0.693605 5.19295 1.83649 3.51472 3.51472C1.83649 5.19295 0.693605 7.33115 0.230582 9.65892C-0.232441 11.9867 0.00519943 14.3995 0.913451 16.5922C1.8217 18.7849 3.35977 20.6591 5.33316 21.9776C7.30655 23.2962 9.62663 24 12 24C15.1826 24 18.2349 22.7357 20.4853 20.4853C22.7357 18.2349 24 15.1826 24 12Z"
                  fill="#224635"
                />
              </g>
            </g>
          </g>
          <path d="M18 18L6 6" stroke="#154734" strokeWidth="1.2" strokeMiterlimit="10" />
          <path d="M6 18L18 6" stroke="#154734" strokeWidth="1.2" strokeMiterlimit="10" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_1986_2231">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
    // <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    //   <g id="x-close">
    //     <path
    //       id="Icon"
    //       d="M18 6L6 18M6 6L18 18"
    //       stroke={stroke}
    //       strokeWidth="2"
    //       strokeLinecap="round"
    //       strokeLinejoin="round"
    //     />
    //   </g>
    // </svg>
  );
};

export default XClose;
